import React, { useState } from "react";
import { Grid } from "@mui/material";

import { useTranslation } from "react-i18next";
import Survey from "./Survey";
import Completed from "./Completed";
import HeaderImage from "../components/HeaderImage";
import Header from "../components/Header";
import { SURVEY_IDS } from "../utils/constants";

const RenaultKangooMultix = (props) => {
  const [isCompleted, setIsCompleted] = useState(false);
  const { t } = useTranslation();

  {
    document.title = " RENAULT KANGOO MULTIX ";
  }

  const surveyId = SURVEY_IDS.RENAULT_KANGOO_MULTIX;

  return (
    <Grid container>
      <Header model={"renaultKangooMultix"} />
      <HeaderImage model={"renaultKangooMultix"} />

      {isCompleted ? <Completed style={{ pt: 10 }} /> : <Survey style={{ pt: 10 }} setIsCompleted={setIsCompleted} surveyId={surveyId} />}
    </Grid>
  );
};

export default RenaultKangooMultix;
